import { Badge, Box } from '@mantine/core';
import { getEnumColor, getEnumLabel } from '../../../../utils/enumUtils';

import { CAMPAIGN_TYPES } from '../../../common/enums/enums';
import { NavLink } from 'react-router-dom';

const TypeCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const colorLookup = {
        Email: 'grape.4',
        Sms: 'blue',
        Rvm: 'teal.6',
        default: 'gray',
    };
    const badgeColor = getEnumColor(CAMPAIGN_TYPES, rowData.type);
    const label = getEnumLabel(CAMPAIGN_TYPES, rowData.type);
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}>
            <Badge
                color={badgeColor}
                size={'md'}>
                {label}
            </Badge>
        </Box>
    );
};

const TypeColumn = () => ({
    accessorKey: 'type',
    header: 'Type',
    size: 2,
    Cell: ({ cell }) => <TypeCell cell={cell} />,
});
export default TypeColumn;
